import hoistNonReactStatics from 'hoist-non-react-statics';
import { Spin } from 'antd';
import { Suspense, SuspenseProps } from 'react';

const UNKNOWN_COMPONENT = 'unknown';

function withSuspense<P extends Record<string, any>>(
  WrappedComponent: React.ComponentType<P>,
  suspenseProps: SuspenseProps,
): React.FC<P> {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const componentDisplayName =
    WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;

  const Wrapped = (props: P) => {
    const { fallback, ...otherSuspenseProps } = suspenseProps;
    return (
      <Suspense fallback={fallback ?? <Spin spinning />} {...otherSuspenseProps}>
        <WrappedComponent {...props} />
      </Suspense>
    );
  };
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  Wrapped.displayName = `Suspense(${componentDisplayName})`;

  hoistNonReactStatics(Wrapped, WrappedComponent);
  return Wrapped;
}
export default withSuspense;
